module.exports = __webpack_public_path__ + "static/media/app-icon.bdab14c8.png";